export const CONTRACT_STATUS_COLORS = {
  submitted: "gold",
  in_progress: "blue",
  completed: "green",
  closed: "default",
};

export const CONTRACT_STATUS_LABELS = {
  submitted: "Submitted",
  in_progress: "In Progress",
  completed: "Completed",
  closed: "Closed",
};

export const CONTRACT_PRIORITIES = ["Urgent", "Important", "Low"];

export const CONTRACT_STATUS_OPTIONS = [
  { value: "submitted", label: "Submitted" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "closed", label: "Closed" },
];

export const CONTRACT_STEPS = [
  { key: "submitted", label: "Submitted" },
  { key: "in_progress", label: "In Progress" },
  { key: "completed", label: "Completed" },
  { key: "closed", label: "Closed" },
];

export const normalizeContractResponse = (response) => {
  const payload = response?.data || {};
  if (Array.isArray(payload)) {
    return { rows: payload, total: payload.length };
  }
  return {
    rows: payload.results || [],
    total: payload.count || 0,
  };
};
